<script lang="ts">
  import {tooltip} from '@/actions/tippy-action';
  import editorInstance from '@/lib/editor/editor';
  import editorStore from '@/lib/editor/editor.store';
  import {get} from 'lodash';
  import {flip} from 'svelte/animate';
  import {writable} from 'svelte/store';

  function hide(htmlElement: HTMLElement) {
    isShowing.update((value: boolean) => {
      if (!htmlElement) return true;
      if (value) {
        // htmlElement.classList.add("!hidden");
        htmlElement.style.display = 'none';
      } else {
        // htmlElement.classList.remove("!hidden");
        htmlElement.style.display = 'block';
      }
      return !value;
    });
  }

  export let item: any;
  let eyeIcon: string;

  // let isShowing = writable(!item.element.classList.contains('!hidden'));
  let isShowing = writable(getComputedStyle(item.element).display !== 'none');

  function onMouseOver(element: HTMLElement) {
    editorInstance.ui.highlight(element);
  }

  function onMouseLeave() {
    editorInstance.ui.removeHighlight();
  }

  function onMouseClick(element: HTMLElement) {
    editorStore.setActiveComponent(element);
  }

  function trunc(str: string) {
    str = str.trim();
    if (str.length > 85) {
      return str.slice(0, 82) + '...';
    }
    return str;
  }

  $: eyeIcon = $isShowing ? 'fa-eye' : 'fa-eye-slash';
</script>

<div class="group w-full">
  <div
    class="border-zinc-300m border-1 flex w-full items-center rounded rounded-2xl border border-gray-300 bg-gray-200 px-4 py-4 group-hover:border-2 group-hover:border-primary"
    on:mouseover={() => onMouseOver(item.element)}
    on:focus={() => onMouseOver(item.element)}
    on:mouseleave={onMouseLeave}
    on:click|stopPropagation|preventDefault={() => onMouseClick(item.element)}
    on:keypress={() => onMouseClick(item.element)}
  >
    <span class="font-xl ml-1 w-3 cursor-grab">
      <i class="fa-sharp fa-regular fa-grip-dots-vertical cursor-grab text-3xl text-gray-500" />
    </span>
    <div class="relative mr-2 flex max-h-10 flex-grow justify-center rounded-xl p-1">
      {#if item.type == 'TextComponent'}
        <p class="text-center text-sm font-bold">
          {trunc(item.element.textContent)}
        </p>
      {:else if item.type == 'ImageComponent'}
        <img src={item.element.querySelector('img')?.src} alt="thumbnail" class="h-10 w-auto" />
      {:else if item.type == 'ClipComponent'}
        Video Clip
      {:else if item.type == 'SVGComponent'}
        <div class="h-10 w-10">
          {@html item.element.innerHTML}
        </div>
      {:else}
        {item.type.replace('Component', '')}
      {/if}
    </div>
    {#if item.element}
      <div
        class="ml-auto block cursor-pointer"
        use:tooltip={'Show/Hide'}
        on:click|stopPropagation|preventDefault={() => hide(item.element)}
        on:keypress={() => hide(item.element)}
      >
        <i class="fa {eyeIcon} text-gray-500 group-hover:text-black" />
      </div>
    {/if}
  </div>
</div>
